import type {AdLocation} from '@frontend/modules/public/ads/AdsModuleTypes'
import {LocationSelectorOptionsGroup} from './LocationSelectorOptionsGroup'

interface Props {
    levels: AdLocation[][]
    headers: string[]
    selectedLocation: AdLocation | null
    keywordsRegexp: RegExp | null
    onSelect: (location: AdLocation) => void
}

// Списки опций (локаций) по уровням для больших экранов (включая планшеты).
export function LocationsSelectorOptionsDesktop(props: Props) {

    const {
        levels,
        headers,
        selectedLocation,
        keywordsRegexp,
        onSelect,
    } = props

    return (
        <div className="flex-1 d-flex flex-row overflow-hidden">
            {levels.map((options: AdLocation[], levelIndex: number) => (
                <LocationSelectorOptionsGroup
                    key={levelIndex}
                    depth={levelIndex}
                    header={headers[levelIndex] || '-'}
                    options={options}
                    selectedLocation={selectedLocation}
                    keywordsRegexp={keywordsRegexp}
                    className={levelIndex === levels.length - 1 ? undefined : 'border-end'}
                    onSelect={onSelect}
                />
            ))}
        </div>
    )
}
